import loadable from '@loadable/component';

// @ts-expect-error ts-migrate(6133) FIXME: 'AboutUsLoadable' is declared but its value is nev... Remove this comment to see the full error message
const AboutUsLoadable = loadable(() => import(/* webpackChunkName: 'about-us' */ './AboutUs'));

// @ts-expect-error ts-migrate(2749) FIXME: 'AboutUsLoadable' refers to a value, but is being ... Remove this comment to see the full error message
const AboutUs = () => <AboutUsLoadable />;

export default AboutUs;
